import progulReducer from "./reducers";

export default progulReducer